import { DialogContentType, Dialog, DialogDimension } from '@metaos/hub-sdk';
import { getCurrentCulture } from 'owa-localize';
import { default as createTaskModule, TaskModuleState } from '../utils/createTaskModule';

export interface AboutDialogState {
    isAboutDialogOpen: () => boolean;
    onOpenAboutDialog: (appId: string) => void;
    taskModuleProps: TaskModuleState;
}

export default function createAboutDialog(): AboutDialogState {
    const { actions, store, usePromiseState } = createTaskModule();
    const isAboutDialogOpen = () => store().isOpen;
    const onOpenAboutDialog = (appId: string): void => {
        const aboutDialogInfo: Dialog = {
            url: `https://teams.microsoft.com/extensibility-apps/platformapp/${appId}/create?metaoshost=outlook&host=metaos&language=${getCurrentCulture()}`,
            type: DialogContentType.Url,
            width: DialogDimension.Large,
            height: DialogDimension.Large,
            title: 'About',
        };
        actions.update(aboutDialogInfo);
        actions.open();
    };

    return {
        isAboutDialogOpen,
        onOpenAboutDialog,
        taskModuleProps: {
            actions,
            store,
            usePromiseState,
        },
    };
}
